"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var constants_1 = require("playable/dist/src/constants");
var lodash_1 = require("lodash");
var ErrorLogger = /** @class */ (function (_super) {
    tslib_1.__extends(ErrorLogger, _super);
    function ErrorLogger(props) {
        var _this = _super.call(this, props) || this;
        _this.logError = function (error) {
            var _a = _this.props, videoID = _a.videoID, engine = _a.engine, logFunction = _a.logFunction, isLive = _a.isLive;
            var videoUrl = (0, lodash_1.get)(engine, 'attachedAdapter.currentUrl', null);
            var errorType = error.errorType, streamProvider = error.streamProvider, streamType = error.streamType;
            logFunction({
                videoID: videoID,
                videoUrl: videoUrl,
                errorType: errorType,
                streamProvider: streamProvider,
                streamType: streamType,
                isLive: isLive,
            });
        };
        _this.subscribeToEvents();
        return _this;
    }
    ErrorLogger.prototype.componentWillUnmount = function () {
        this.unSubscribeFromEvents();
    };
    ErrorLogger.prototype.subscribeToEvents = function () {
        var eventEmitter = this.props.eventEmitter;
        eventEmitter.on(constants_1.VIDEO_EVENTS.ERROR, this.logError);
    };
    ErrorLogger.prototype.unSubscribeFromEvents = function () {
        var eventEmitter = this.props.eventEmitter;
        eventEmitter.off(constants_1.VIDEO_EVENTS.ERROR, this.logError);
    };
    ErrorLogger.prototype.render = function () {
        return null;
    };
    return ErrorLogger;
}(react_1.default.Component));
exports.default = ErrorLogger;
//# sourceMappingURL=error-logger.js.map